import {
  Box,
  Container,
  Typography,
  Grid,
  useMediaQuery,
  Icon,
} from "@mui/material";
import React, { useState } from "react";
import { icons, images } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { useNavigate } from "react-router-dom";

const sectionData = [
  {
    id: 1,
    title: "Phone Line",
    price: "£27.99",
    bgColor: "linear-gradient(to right, #eeeeee, #cde1ff)",
    // bgColor: allColors.brightGray,
    rightImg: images.phoneLineRespImg,
    options: [
      {
        id: 1,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Phone line rental",
      },
      {
        id: 2,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Free handset of your choice",
      },
      {
        id: 3,
        image: icons.circleEuro1Icon,
        icon: "currency_pound",
        title: "Pay as you go",
      },
      {
        id: 4,
        image: icons.circlePlusBlackIcon,
        icon: "add",
        title: "Call features",
      },
    ],
    showImage: false,
    showMore: false,
  },
  {
    id: 2,
    title: "Phone & Calls",
    price: "£32.99",
    bgColor: "linear-gradient(to right, #cde1ff, #88b7ff)",
    rightImg: images.phoneCallsRespImg,
    options: [
      {
        id: 1,
        image: icons.circlePhone1Icon,
        icon: "phone_in_talk",
        title: "Phone line rental",
      },
      {
        id: 2,
        image: icons.circleCheckBlackIcon,
        icon: "check",
        title: "Free handset of your choice",
      },
      {
        id: 3,
        image: icons.circleinfinityIcon,
        icon: "all_inclusive",
        title: "Unlimited UK landline & mobile calls",
      },
      {
        id: 4,
        image: icons.circlePlusBlackIcon,
        icon: "add",
        title: "Call features",
      },
    ],
    showImage: true,
    showMore: false,
  },
];

const PhoneLine = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [phoneOnlyData, setPhoneOnlyData] = useState(sectionData);

  const handleShowMore = (inddddd) => {
    let tempArrr = [...phoneOnlyData];
    tempArrr[inddddd].showMore = !tempArrr[inddddd].showMore;
    setPhoneOnlyData(tempArrr);
  };

  return (
    <Container
      sx={{
        maxWidth: "1250px !important",
        textAlign: "center",
        paddingBottom: "60px",
      }}
      id="phone-line"
    >
      <Grid container spacing={3} alignItems={"stretch"}>
        {phoneOnlyData.map((itemmmm, index) => {
          return (
            <Grid item xs={12} md={itemmmm.showImage ? 8.5 : 3.5}>
              <Box
                sx={{
                  background: itemmmm.bgColor,
                  padding: {
                    xs:
                      index == 0 ? "15px 0px 24px 18px" : "15px 24px 24px 18px",
                    sm: "24px 24px 24px 44px",
                  },
                  borderRadius: "20px",
                  position: "relative",
                  // height: "100%", // Full height of Grid item
                  display: "flex",
                  flexDirection: "column", // Ensures that content stacks vertically
                  justifyContent: "space-between", // Stretches content vertically
                }}
              >
                <Box
                  sx={{
                    background: allColors.jasmine,
                    borderRadius: "20px",
                    padding: "5px",
                    width: "68%",
                    display: { xs: "block", sm: "none" },
                    marginTop: "10px",
                    textAlign: "center",
                    margin: "0 auto",
                    marginBottom: "12px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Raleway",
                      fontSize: { xs: "20px", md: "28px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                    }}
                  >
                    {itemmmm.title}{" "}
                  </Typography>
                </Box>
                <Grid
                  container
                  spacing={3}
                  alignItems={{ xs: "center", sm: "flex-end" }}
                >
                  <Grid item xs={6.5} sm={itemmmm.showImage ? 5 : 12}>
                    <Box
                      sx={{
                        background: allColors.jasmine,
                        borderRadius: "10px",
                        padding: "5px 0",
                        width: "72%",
                        display: { xs: "none", sm: "block" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Raleway",
                          fontSize: { xs: "20px", md: "28px" },
                          color: allColors.jetBlack,
                          fontWeight: "400",
                        }}
                      >
                        {itemmmm.title}{" "}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "Squad-Regular",
                        fontSize: { xs: "40px", md: "50px" },
                        color: allColors.jetBlack,
                        fontWeight: "700",
                        textAlign: "left",
                        marginTop: "10px",
                        marginLeft: { xs: "20px", sm: 0 },
                      }}
                    >
                      {itemmmm.price}
                      <span
                        style={{ fontSize: isSmallScreen ? "10px" : "14px" }}
                      >
                        p/m
                      </span>
                    </Typography>

                    {itemmmm.options.map((optiionn) => {
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginBottom: "10px",
                            marginLeft: { xs: "5px", sm: 0 },
                          }}
                        >
                          {optiionn.icon == "phone_in_talk" ||
                          optiionn.icon == "currency_pound" ? (
                            <img
                              src={optiionn.image}
                              alt={optiionn.image}
                              style={{
                                width: isSmallScreen ? "35px" : "45px",
                                height: isSmallScreen ? "35px" : "45px",
                                marginRight: "10px",
                              }}
                            />
                          ) : (
                            <Box
                              sx={{
                                background: allColors.jetBlack,
                                borderRadius: "50%",
                                padding: { xs: "5px", sm: "10px" },
                                marginRight: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Icon
                                sx={{
                                  color: index == 0 ? "#eeeeee" : "#cde1ff",
                                }}
                              >
                                {optiionn.icon}
                              </Icon>
                            </Box>
                          )}
                          <Typography
                            sx={{
                              fontSize: { xs: "12px", sm: "14px" },
                              color: allColors.jetBlack,
                              fontWeight: "400",
                              textAlign: "left",
                            }}
                          >
                            {optiionn.title}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Grid>
                  <Grid
                    item
                    xs={5.5}
                    md={5}
                    sx={{
                      display: { xs: "block", sm: "none" },
                    }}
                  >
                    <img
                      src={itemmmm.rightImg}
                      style={{ width: isSmallScreen ? "100%" : "192px" }}
                    />
                  </Grid>
                  {itemmmm.showImage && (
                    <Grid
                      item
                      xs={12}
                      md={7}
                      sx={{
                        position: "relative",
                        display: { xs: "none", sm: "flex" },
                      }}
                    >
                      <Box
                        sx={{
                          background: allColors.blueBerry,
                          position: "absolute",
                          borderRadius: "50%",
                          height: "120px",
                          width: "120px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "10px",
                          right: "70px",
                          top: "-40px",
                          zIndex: 99,
                        }}
                      >
                        <Typography
                          sx={{
                            color: allColors.jetBlack,
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "20px",
                          }}
                        >
                          Choose from our{" "}
                          <a
                            href={"#handsets"}
                            style={{
                              color: allColors.jetBlack,
                              cursor: "pointer",
                            }}
                          >
                            <span style={{ textDecoration: "underline" }}>
                              range of handsets
                            </span>
                          </a>
                        </Typography>
                      </Box>
                      <Box
                        alignSelf={"flex-end"}
                        sx={{
                          width: "auto",
                          // height: "85%",
                          // margin: "30px auto 0",
                        }}
                      >
                        <img
                          src={images.phoneCallsImg}
                          style={{
                            width: "100%",
                            height: "100%",
                            zIndex: 999,
                            position: "relative",
                          }}
                        />
                      </Box>
                    </Grid>
                  )}
                </Grid>
                {itemmmm.showMore && (
                  <Typography
                    sx={{
                      fontSize: { xs: "12px", sm: "14px" },
                      color: allColors.jetBlack,
                      fontWeight: "400",
                      textAlign: "center",
                      margin: "20px 0",
                    }}
                  >
                    VAT excluded from price. Contract length of 18, 24 or 36
                    months. £60 digital installation upgrade fees may apply.
                    Handset free of charge. £30 handset delivery charge applies.{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/tariff-guide")}
                    >
                      Call charges
                    </span>
                    .{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/tariff-guide")}
                    >
                      International call rates
                    </span>
                    .{" "}
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => navigate("/voip-terms-&-conditions")}
                    >
                      Full T&Cs
                    </span>
                    .
                  </Typography>
                )}
              </Box>
              <Box
                sx={{
                  // position: "absolute",
                  // bottom: "-15px",
                  // left: "40%",
                  position: "relative",
                  marginTop: "-22px",
                }}
              >
                {!itemmmm.showMore ? (
                  <GlobalButton
                    handleClickBtn={() => handleShowMore(index)}
                    title={"Show more"}
                    style={{
                      background: allColors.white,
                      color: allColors.jetBlack,
                      border: `1px solid ${allColors.frenchSkyBlue}`,
                      borderRadius: "10px",
                      fontSize: "12px",
                      padding: { xs: "10px 40px", sm: "10px 20px" },
                    }}
                  />
                ) : (
                  <a href={"#contact-us"}>
                    <GlobalButton
                      handleClickBtn={() => handleShowMore(index)}
                      title={"Switch today"}
                      style={{
                        background: allColors.blueCrayola,
                        color: allColors.white,
                        border: `1px solid ${allColors.blueCrayola}`,
                        borderRadius: "10px",
                        fontSize: "12px",
                        padding: { xs: "10px 40px", sm: "10px 20px" },
                      }}
                    />
                  </a>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default PhoneLine;
